module.exports = __webpack_public_path__ + "static/media/reports-icon.447b73eb.svg";